var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Play_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0c3.861 0 7 3.139 7 7s-3.139 7-7 7-7-3.139-7-7 3.139-7 7-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Play_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .56C0 .117.486-.148.855.088l4.067 2.535a.565.565 0 0 1 0 .958L.855 6.115A.556.556 0 0 1 0 5.644Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Play_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#456FC7",
    d: "M0 0h14v14H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Play_svg__b)",
    transform: "translate(4.996 3.906)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h5.187v6.203H0z"
  }))));
};
export default SvgPlay;